import { render, staticRenderFns } from "./ProfileOrganizationTab.vue?vue&type=template&id=565ebe58"
import script from "./ProfileOrganizationTab.vue?vue&type=script&lang=js"
export * from "./ProfileOrganizationTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports